export default __webpack_public_path__ + "static/dummy-0b44053856847ff883cb9547e0238c26.png";